export enum HintTemplateTypes {
  Text,
  TextList,
  Template,
}
